import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useStyles } from './useStyles';
import { getFlightTaskComments } from '../../../selectors/sended-data';

export const FlightTaskComment = memo(() => {
    const classes = useStyles();
    const comments = useSelector(getFlightTaskComments);
    const { t: translate } = useTranslation();

    return comments && comments.length > 0 ? (
        <table className={classes.table}>
            <thead>
                <tr className={classes.header}>
                    <th className={classes.headerCell}>{translate('leg')}</th>
                    <th className={classes.headerCell}>{translate('comment')}</th>
                </tr>
            </thead>
            {comments.map(({ flight, comment }, index) => (
                <tbody key={index} {...(index % 2 !== 1 && { className: classes.secondaryRow })}>
                    <tr>
                        <td className={classes.flightColumn}>{flight}</td>
                        <td className={classes.itemText}>{comment}</td>
                    </tr>
                </tbody>
            ))}
        </table>
    ) : (
        ''
    );
});
